import React, { useState } from 'react';
import { LearnerCourseCard, LearnerProgramCard } from '../../components/CourseCard';
import { Card, PageHeader } from '../../components/ui';
import { useLms } from '../../context/LmsContext';
import { derivedAssignmentStatus, getProgramProgress } from '../../utils/lmsSelectors';

export default function MyCourses() {
  const { data, currentUser } = useLms();
  const [filter, setFilter] = useState('all');
  const assignments = data.assignments.filter((assignment) => assignment.assignedToUserId === currentUser.id && assignment.status !== 'revoked');
  const programAssignments = (data.programAssignments || []).filter((assignment) => assignment.assignedToUserId === currentUser.id && assignment.status !== 'revoked');
  const filteredCourses = filter === 'all' ? assignments : assignments.filter((assignment) => derivedAssignmentStatus(data, assignment) === filter);
  const filteredPrograms = filter === 'all' ? programAssignments : programAssignments.filter((assignment) => getProgramProgress(data, assignment).status === filter);
  return (
    <>
      <PageHeader title="My courses and programs" description="Courses and bundled programs assigned by Admin, grouped by current status and due date." />
      <Card><label>Status <select value={filter} onChange={(e) => setFilter(e.target.value)}><option value="all">All</option><option value="not_started">Not Started</option><option value="in_progress">In Progress</option><option value="completed">Completed</option><option value="overdue">Overdue</option><option value="needs_review">Needs Review</option></select></label></Card>
      {filteredPrograms.length > 0 && (
        <>
          <h2>Programs</h2>
          <div className="course-grid">{filteredPrograms.map((assignment) => <LearnerProgramCard key={assignment.id} data={data} programAssignment={assignment} />)}</div>
        </>
      )}
      <h2>Courses</h2>
      <div className="course-grid">{filteredCourses.map((assignment) => <LearnerCourseCard key={assignment.id} data={data} assignment={assignment} />)}</div>
    </>
  );
}
